module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_8004.f94e0e0d.png";